module.exports = __webpack_public_path__ + "static/img/y3.56c3054.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y3.jpg
// module id = db91
// module chunks = 1